import { AxiosError } from 'axios';
import { ErrorCase } from './types';

const GENERAL_ERROR_MESSAGE = '서비스에 접속할 수 없습니다.\n 새로고침을 하거나 잠시 후 다시 접속해 주시기 바랍니다.';
const errorMessages: ErrorCase = {
  400: {
    UNSUPPORTED_IMAGE_FORMAT: 'general.image_filetype_validation_message',
    UNSUPPORTED_AUDIO_FORMAT: 'This File has an unsupported audio format.',
    AUDIO_PLAYTIME_TIMEOUT: '파일의 playtime이 초과되었습니다.',
    UNSUPPORT_STATUS_TYPE: 'chapter.edit_save_publish_chapter_warning_alert_message',
    STORY_UNDER_REVIEW: 'contest.edit_draft_alert_description',
    COULD_NOT_UPDATE_STORY_LANGUAGE: GENERAL_ERROR_MESSAGE,
    EMAIL_NOT_VERIFIED: 'register.userinfo_email_certification_message',
  },
  403: {
    NOT_ALLOWED_TITLE_TYPE: '스토리에 권한이 없습니다.',
    NOT_OWNER_USER: '권한이 없는 유저입니다.',
    EXPIRED_PURCHASED_CHAPTER: '에피소드가 만료되었어요. 타이틀로 이동합니다.',
  },
  404: {
    // CHAPTER_NOT_FOUND: 'go to 404',
    // NOT_EXIST_TITLE: 'go to 404',
    NOT_EXIST_USER: '존재하지 않는 유저입니다.',
    NOT_EXIST_TITLE: '존재하지 않는 작품입니다.',
    CHAPTER_NOT_FOUND: '존재하지 않는 에피소드입니다.',
    NOT_EXIST_COMMENT: '존재하지 않는 댓글입니다.',
    PERMISSION_DENIED: 'go to permission denied',
  },
  409: {
    // 보안에러
  },
  500: {
    TYPEORM_QUERY_ERROR: GENERAL_ERROR_MESSAGE,
    UNKNOWN_ERROR: GENERAL_ERROR_MESSAGE,
  },
};

const renderErrorMessage = (error: AxiosError) => {
  return errorMessages?.[error.response?.data?.statusCode]?.[error.response?.data?.code] ?? GENERAL_ERROR_MESSAGE;
};

export { renderErrorMessage };
